import React, { PropsWithChildren } from "react";
import { Box } from "@chakra-ui/react";
import Router from "@root/routes";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reduxStore from "@store/index";
import { ChakraWrapper } from "@components/index";
import { I18nextProvider } from "react-i18next";
import i18n from "@root/i18n";
import "./rc-pagination.css";
import { ProjectsProvider } from "./context/projects-context";
import { TourGuideProvider } from "./context/tour-guide-context";
import { BrandingContextProvider } from "./context/branding-context";

export const { store, persistor } = reduxStore();

// Local wrapper to avoid TypeScript JSX typing issues with react-redux Provider
const StoreProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);

function App() {
  return (
    <StoreProvider>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <Box className="App">
            <div id="scrollableDiv" className="hide-scrollbar">
              <BrandingContextProvider>
                <ProjectsProvider>
                  <TourGuideProvider>
                    <ChakraWrapper>
                      <Router />
                    </ChakraWrapper>
                  </TourGuideProvider>
                </ProjectsProvider>
              </BrandingContextProvider>
            </div>
          </Box>
        </I18nextProvider>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
